import * as React from "react"

export default function Lock({ height = "100px" }) {
  return (
    <svg
      id="prefix__Layer_1"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      width="auto"
      height={height}
    >
      <style>{".prefix__st0{fill:#134563}"}</style>
      <g id="prefix__Icon-Lock" transform="translate(284 430)">
        <path
          className="prefix__st0"
          d="M-237.7-401.3h-3v-6.4c0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3v6.4h-3v-6.4c0-7.9 6.4-14.3 14.3-14.3s14.3 6.4 14.3 14.3v6.4"
          id="prefix__Fill-66"
        />
        <path
          className="prefix__st0"
          d="M-239.2-374.1h-25.6c-2.6 0-4.8-2.2-4.8-4.8v-19.2c0-2.6 2.2-4.8 4.8-4.8h25.6c2.6 0 4.8 2.2 4.8 4.8v19.2c0 2.7-2.2 4.8-4.8 4.8zm-25.6-25.6c-.9 0-1.6.7-1.6 1.6v19.2c0 .9.7 1.6 1.6 1.6h25.6c.9 0 1.6-.7 1.6-1.6v-19.2c0-.9-.7-1.6-1.6-1.6h-25.6z"
          id="prefix__Fill-67"
        />
        <path
          className="prefix__st0"
          d="M-248.8-393.3c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2 3.2 1.5 3.2 3.2"
          id="prefix__Fill-68"
        />
        <path
          className="prefix__st0"
          id="prefix__Fill-69"
          d="M-251.2-393.3h-1.6l-1.6 9.6h4.8l-1.6-9.6"
        />
      </g>
    </svg>
  )
}
